<ng-container *transloco="let t;">

  <p-card>
    <app-reporting-table
      [type]="'acroles'"
    ></app-reporting-table>
  </p-card>

</ng-container>
